import { Redirect, Route, useLocation } from 'quartz-routing/react-router';
import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { getHistory } from '../routing/history';
import { jsx as _jsx } from "react/jsx-runtime";
const AcademyRoute = props => {
  const {
    hash,
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const queryParams = new URLSearchParams(getHistory().location.search);
  const flowKey = getFlowKey();
  const isAcademyEmbedded = flowKey === Flow.Academy && Boolean(queryParams.get('_seia'));
  if (isAcademyEmbedded) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: `/${Flow.AcademyEmbedded}`,
        search: searchParams.toString(),
        hash
      }
    });
  }
  return /*#__PURE__*/_jsx(Route, Object.assign({}, props));
};
export default AcademyRoute;